import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { login } from "../services/authService";
import { FaEnvelope, FaLock, FaSpinner } from "react-icons/fa";
import { jwtDecode } from "jwt-decode";
import logo from "../assets/logo.jpg";
import "../css/LoginForm.css"; // Import CSS

const LoginForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      const data = await login(email, password);
      localStorage.setItem("token", data.token);

      const decodedToken = jwtDecode(data.token);
      console.log(decodedToken); // Cek isi token di console

      if (decodedToken.role === "admin") {
        navigate("/dashboard");
      } else if (decodedToken.role === "karyawan") {
        navigate("/employee-dashboard");
      } else {
        alert("Role tidak dikenali!");
      }
    } catch (err) {
      setError(err);
    } finally {
      setLoading(false); // Matikan loading setelah request selesai
    }
  };

  return (
    <div className="loginbody">
      <div className="login-container">
        <img src={logo} alt="Karyawan Teladan" className="login-logo" />
        {error && <p className="error">{error}</p>}

        <form onSubmit={handleSubmit}>
          <div className="input-group">
            <FaEnvelope className="input-icon" />
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <FaLock className="input-icon" />
            <input
              type="password"
              placeholder="Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className={loading ? "loading" : ""}
          >
            {loading ? <FaSpinner className="spinner" /> : "Login"}
          </button>
        </form>

        <div className="forgot-password">
          <Link to="/reset-password">Lupa Password?</Link>
        </div>
      </div>
    </div>
  );
};

export default LoginForm;
